<template>
    <b-container>
        <b-card bg-variant="danger" text-variant="white" :title="$globalStore.translate('download.file.error.header')" v-if="error">
            <b-card-text>
                {{ 'download.file.error.content' | translate }}
            </b-card-text>
        </b-card>

        <b-card bg-variant="danger" text-variant="white" :title="$globalStore.translate('download.file.not.found.header')" v-if="invalid">
            <b-card-text>
                {{ 'download.file.not.found.content' | translate }}
            </b-card-text>
        </b-card>

        <b-card :title="$globalStore.translate('download.title')" v-if="!invalid && !expired">
            <b-card-text>
                <p>{{ 'download.expire' | translate(expire, daysUntilExpire) }}</p>

                <b-table striped hover :items="files" :fields="filesFields">
                    <template slot="index" slot-scope="data">
                        {{ data.index }}
                    </template>

                    <template slot="size" slot-scope="data">
                        {{ data.item.size | bytes }}
                    </template>

                    <template slot="download" slot-scope="data">
                        <a :href="data.item.link">{{ 'download.table.body.download' | translate }}</a>
                    </template>
                </b-table>
                <div v-if="zipDownloadLink">
                    <hr />
                    <br>
                    <p>{{ 'download.zip' | translate }}</p>
                    <p><a :href="zipDownloadLink">{{ 'download.zip.link' | translate }}</a></p>
                </div>
            </b-card-text>
        </b-card>
    </b-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Download",
        data() {
            return {
                files: [],
                filesFields: [
                    {
                        key: 'index',
                        label: '#',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: this.$globalStore.translate('download.table.name'),
                        sortable: true
                    },
                    {
                        key: 'size',
                        label: this.$globalStore.translate('download.table.size'),
                        sortable: true
                    },
                    {
                        key: 'download',
                        label: this.$globalStore.translate('download.table.download')
                    },
                ],
                invalid: false,
                error: false,
                expire: -1,
                expired: false,
                daysUntilExpire: 0,
                zipDownloadLink: null
            }
        },
        methods: {
            getFileInfo: function () {
                axios.get('https://drop.rautec.de/api/files/' + this.$route.params.token)
                    .then(response => {
                        if (response.data.files && !response.data.expired) {
                            this.files = response.data.files;
                            this.zipDownloadLink = response.data.zip;

                            let date = new Date(response.data.expire * 1000);
                            this.expire = date.toLocaleDateString('de');

                            let now = new Date();

                            let msPerDay = 1000 * 60 * 60 * 24;
                            let utc1 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
                            let utc2 = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

                            this.daysUntilExpire = Math.abs(Math.floor((utc2 - utc1) / msPerDay));

                            this.invalid = false;
                        } else {
                            this.invalid = true;
                        }
                    }).catch(reason => {
                    this.error = true;
                });
            }
        },
        watch: {
            $route: function (to, from) {
                this.getFileInfo();
            },
            invalid: function (value) {
                if (value) {
                    this.files = [];
                }
            }
        },
        mounted() {
            this.getFileInfo();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Download.vue